import { useSelector } from "react-redux";
import { useRole } from "./use-role";

// 权限级别常量
export const AUTH_LEVEL = {
    READ_ONLY: 1,    // 只读权限
    WRITE: 2,        // 可写权限
    FULL_ACCESS: 3,  // 完全访问权限
};

/**
 * 通用权限hook
 * @param {string} code - 权限代码
 * @param {number} level - 最低权限级别，默认为1（只读）
 * @returns {boolean} - 是否有权限
 */
export const useAuth = (code, level = AUTH_LEVEL.READ_ONLY) => {
    const role = useRole();
    const permission = useSelector(state => state.Auth.permission);

    // role === 1 是超级管理员，拥有所有权限
    return role === 1 || (permission && permission[code] >= level);
};

/**
 * 只读权限hook (permission >= 1)
 * @param {string} code - 权限代码
 * @returns {boolean} - 是否有只读权限
 */
export const useAuthReadOnly = (code) => {
    return useAuth(code, AUTH_LEVEL.READ_ONLY);
};

/**
 * 可写权限hook (permission >= 2)
 * @param {string} code - 权限代码
 * @returns {boolean} - 是否有可写权限
 */
export const useAuthEditable = (code) => {
    return useAuth(code, AUTH_LEVEL.WRITE);
};

/**
 * 完全访问权限hook (permission >= 3)
 * @param {string} code - 权限代码
 * @returns {boolean} - 是否有完全访问权限
 */
export const useAuthFullAccess = (code) => {
    return useAuth(code, AUTH_LEVEL.FULL_ACCESS);
};